import { DomainEntityConfiguration } from '@web-config-app/core';

export const filterEntitiesByPermissions = (
  entityConfigs: Record<string, DomainEntityConfiguration>,
  hasAllPermissions: (permissionsToCheck: string[]) => boolean,
): Record<string, DomainEntityConfiguration> => {
  const filtered: Record<string, DomainEntityConfiguration> = {};

  Object.entries(entityConfigs).forEach(([entityId, entityConfig]) => {
    const { permissions } = entityConfig;

    if (!permissions?.length || hasAllPermissions(permissions)) {
      filtered[entityId] = entityConfig;
    }
  });

  return filtered;
};
